export default {
   "Search": "Search",
   "Modules": "Modules",
   "Users": "Users",
   "Email": "Email",
   "Phone Number": "Phone Number",
   "Address": "Address",
   "Company login": "Company login",
  /***************** Sidebar *********/
    "Dashboard": "Dashboard",
 /****************** Navbar *************/
    "Logout": "Logout",
    "Profile": "Profile",
    "Invoices":"Invoices",
 /****************** Dashboard Datatable ***********/
   "Title": "Title",
   "Version": "Version",
   "Module Slug": "Module Slug",
   "Progress": "Progress",
   "Attempted on": "Attempted on",
   "Score":"Score",
   "Your Quizes":"Your Quizes",
   "Your Modules": "Your Modules",
   "Launch":"Launch",
   "Details":"Details",
   "Jump To Quiz": "Jump To Quiz",
   "Rows per page": "Rows per page",
 /****************** Users ***********/
    "Name": "Name",
    "Actions": "Actions",
    "Image" : "Image",
    "Salutation": "Salutation",
    "Invite Users": "Invite Users",
    "Date of Birth": "Date of Birth",
    "All cards": "All cards",
    "Card added successfully":"Card added successfully",
    "Remove" :"Remove",
    "User Profile": "User Profile",
    "All Cards": "All Cards",
    "Add Card" : "ADD CARD",
    "Primary": "Primary",
    "Are you sure want to remove?": "Are you sure want to remove?",
    "Subscribe" : "Subscribe",
    "Are you sure you want to purchase?": "Are you sure you want to purchase?",
    "Yes":"Yes",
    "No":"No",
    "You dont seem to have a card added to your profile":"You dont seem to have a card added to your profile",
    "Go to profile": "Go to profile",
    "Place of birth": "Place of birth",
 /****************** Courses ***********/
    "Filters":"Filters",
    "Know More": "see details",
    "Purchased": "Purchased",
    "Included" : "Included",
    "What Will you Learn?": "What Will you Learn?",
    "Requirements" : "Requirements",
    "Description" : "Description",
    "PLAY NOW": "PLAY NOW",
    "Language": "Language",
    "Contact us": "Contact us",
    "Write to Company Representative": "Write to Company Representative",
    "Module": "Module",
    "Subject": "Subject",
    "Body": "Body",
    "Send copy to myself" : "Send copy to myself",
    "Status": "Status",
    "Join date": "Join date",
    "Change status": "Change status",
    "Active": "Active",
    "Inactive":"Inactive",
    "disable": "disable",
    "pending": "pending",
    "Subscribed":"Subscribed",
    "Unsubscribed":"Unsubscribed",
    "English":"English",
    "German":"German",
    "User updated successfully": "User updated successfully",
    "User created successfully": "User created successfully",
    "Documents": "Documents",
    'No modules found': 'No modules found',
    'Course': 'Course',
    'Powered by Evaluation Experts': 'Powered by Evaluation Experts',
    'Your attempted modules': 'Your attempted modules',
    'No data found': 'No data found',
    'Search documents': 'Search documents',
    'Time Spent' : 'Time Spent',
    'From': 'From',
    'To': 'To',
    'Play':'Play',
    'Your sessions': 'Your sessions',
    'Your attempts': 'Your attempts',
    'Inbox': 'Inbox',
    'Settings': 'Settings',
    'Update document' : 'Update document',
    'View': 'View',
    'User Documents':'User Documents',
    'Roles': 'Roles',
    'Group': 'Groups',
    'Comment (optional)': 'Comment (optional)',
    'Due date':'Due date',
    'Select file': 'Select file',
    'Document name':'Document name',
    'Days until': 'Days until',
    'Template' : 'Template',
    'Update': 'Update',    
    'Edit': 'Edit',
    'Uploaded by': 'Uploaded by',
    'Uploaded on': 'Uploaded on',
    'Type':'Type',
    'Action':'Action',
    'Stage 1': 'Stage 1',
    'Stage 2': 'Stage 2',
    'Set Name': 'Set Name',
    'Show next': 'Show next',
    'Show from':'Show from',
    'Name is required': 'Name is required',
    'Invalid Email address': 'Invalid Email address',
    'Phone Number is required': 'Phone Number is required',
    'Salutation is required':'Salutation is required',
    'Address is required': 'Address is required',
    'Group admin is required':'Group admin is required',
    'Groups are required': 'Groups are required',
    'Status is required': 'Status is required',
    'Date is required': 'Date is required',
    'Mr': 'Mr',
    'Ms': 'Ms',
    'Mrs':'Mrs',
    'Document updated successfully':'Document updated successfully',
    'Create document':'Create document',
    'Set Filter':'Set Filter',
    'Location':'Location',
    'Procedure': 'Procedure',
    'Class':'Class',
    'Maker':'Maker',
    'Serial maker': 'Serial maker',
    'Stock':'Stock',
    'Good until date': 'Good until date',
    'Equipment':'Equipment',
    'Number in stock': 'Number in stock',
    'Serial number':'Serial number',
    'Location is required':'Location is required',
    'Class is required':'Class is required',
    'Maker is required': 'Maker is required',
    'Number in stock is required':'Number in stock is required',
    'Goods until date is required': 'Goods until date is required',
    'Serial number is required':'Serial number is required',
    'Procedure is required':'Procedure is required',
    'Description is required':'Description is required',
    'Equipment created successfully':'Equipment created successfully',
    'Equipment updated successfully':'Equipment updated successfully',
    'Group name': 'Group name',
    'Group admins': 'Group admins',
    'Group name is required':'Group name is required',
    'Users are required': 'Users are required',
    'Course are required':'Course are required',
    'Documents are required':'Documents are required',
    'Company settings': 'Company settings',
    'Company Color': 'Company Color',
    'Session login time': 'Session login time',
    'Primary color is required':'Primary color is required',
    'Company settings updated successfully':'Company settings updated successfully',
    'Intellectual Property Rights': 'Intellectual Property Rights',
    'Unless otherwise indicated, the Site and all source code, database, functionality, software, website designs, audio, video, text, photographs, and other learning material on the Site (collectively, the “Content”) and the trademarks, service marks, and logos contained therein (collectively, the “Marks”) are protected by copyright and trademark laws and various other intellectual property rights and unfair competition laws of Germany, foreign jurisdictions, and international conventions.': 'Unless otherwise indicated, the Site and all source code, database, functionality, software, website designs, audio, video, text, photographs, and other learning material on the Site (collectively, the “Content”) and the trademarks, service marks, and logos contained therein (collectively, the “Marks”) are protected by copyright and trademark laws and various other intellectual property rights and unfair competition laws of Germany, foreign jurisdictions, and international conventions.',
    'I accept this (required)': 'I accept this (required)',
    'Please subscribe to a course':'Please subscribe to a course',
    'Your score': 'Your score',
    'Max Score' : 'Max Score',
    'Time taken':'Time taken',
    'Pass Score':'Pass Score',
    'No subscribed courses found':'No subscribed courses found'




   


  };